module.exports = __webpack_public_path__ + "img/mining_med.02de6318.webp";